import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TranslationProvider from '../../../providers/TranslationProvider';
import AccountLabel from '../AccountLabel';
import { Label } from '../../Form';
import { TextInput } from '../../Input';
import TextArea from '../../TextArea';
import './AccountConcierge.scss';

const AccountConcierge = ({
  status, onCompanyChange, onReasonChange, isViaConciergeURL,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const outerElementRef = useRef(null);
  const scrollPromiseRef = useRef(null);

  useEffect(() => {
    if (isViaConciergeURL) {
      setIsExpanded(true);

      scrollPromiseRef.current = new Promise((resolve) => {
        setTimeout(() => {
          if (outerElementRef.current) {
            const { y } = outerElementRef.current.getBoundingClientRect();
            window.scrollTo(0, y);
          }
          resolve();
        }, 1);
      });
    }
  }, [isViaConciergeURL]);

  const handleShowConcierge = () => {
    setIsExpanded(!isExpanded);
  };

  const acceptedMessage = (
    <div className="AccountProfile__row-description">
      <TranslationProvider translationKey="concierge_registered">
        <span>
          You are registered as a concierge.
        </span>
      </TranslationProvider>
    </div>
  );

  const pendingMessage = (
    <div className="AccountProfile__row-description">
      <TranslationProvider translationKey="concierge_pending">
        <span>
          Thanks! Our team will review your request and respond within 2 business days.
        </span>
      </TranslationProvider>
    </div>
  );

  const registrationForm = (
    <>
      <div className="AccountProfile__row-description">
        <TranslationProvider translationKey="concierge_registration_intro">
          <span>
            If you frequently book reservations on behalf of others, you can join our concierge program.
          </span>
        </TranslationProvider>
        <span>{' '}</span>
        {!isExpanded && (
          <button className="AccountConcierge__apply" type="button" onClick={handleShowConcierge}>
            <TranslationProvider translationKey="apply_here_link">
              <span>Apply Here</span>
            </TranslationProvider>
          </button>
        )}
      </div>
      {isExpanded && (
        <>
          <Label>
            <TranslationProvider translationKey="company_name_input_label">
              Company Name
            </TranslationProvider>
            <TranslationProvider translationKey="company_name_input">
              <TextInput
                placeholder="Company name..."
                name="accountConciergeCompany"
                onChange={onCompanyChange}
              />
            </TranslationProvider>
          </Label>
          <Label>
            <TranslationProvider translationKey="reason_for_requesting_input_label">
              Reason for Requesting
            </TranslationProvider>
            <TranslationProvider translationKey="reason_for_requesting_input">
              <TextArea
                placeholder="Reason for requesting..."
                name="accountConciergeReason"
                onChange={onReasonChange}
              />
            </TranslationProvider>
          </Label>
        </>
      )}
    </>
  );
  return (
    <div
      className="AccountProfile__row AccountConcierge"
      ref={outerElementRef}
    >
      <AccountLabel translationKey="concierge_registration_title">
        Concierge Registration
      </AccountLabel>
      {status === 'accepted' && acceptedMessage}
      {status === 'pending' && pendingMessage}
      {!status && registrationForm}
    </div>
  );
};

AccountConcierge.propTypes = {
  status: PropTypes.string,
  onCompanyChange: PropTypes.func.isRequired,
  onReasonChange: PropTypes.func.isRequired,
  isViaConciergeURL: PropTypes.bool,
};

AccountConcierge.defaultProps = {
  status: null,
  isViaConciergeURL: false,
};

export default AccountConcierge;
